export default __webpack_public_path__ + "static/media/truckstop.8608fa5c.png";